import { motion } from "framer-motion";
import { Home, Sparkles, PackageOpen, HardHat, Check } from "lucide-react";

const services = [
  {
    id: "residential",
    testid: "service-card-residential",
    icon: Home,
    title: "Residential Maintenance",
    desc: "Weekly, bi-weekly, or monthly visits that keep your home guest-ready around the clock.",
    points: ["Kitchens & baths sanitized", "Dusting ceiling to baseboard", "Floors vacuumed & mopped"],
    big: true,
  },
  {
    id: "deep-clean",
    testid: "service-card-deep-clean",
    icon: Sparkles,
    title: "Deep Cleaning",
    desc: "A top-to-bottom reset for seasons, holidays, or whenever life gets busy.",
    points: ["Inside appliances & cabinets", "Grout & fixture detailing", "Baseboards, vents & fans"],
  },
  {
    id: "move-in-out",
    testid: "service-card-move-in-out",
    icon: PackageOpen,
    title: "Move-In / Move-Out",
    desc: "Deposit-ready cleans for renters and flawless first impressions for sellers.",
    points: ["Empty-home detailing", "Cabinet & closet interiors", "Realtor & landlord approved"],
  },
  {
    id: "post-construction",
    testid: "service-card-post-construction",
    icon: HardHat,
    title: "Post-Construction",
    desc: "From drywall dust to final polish — turning job sites into move-in-ready spaces.",
    points: ["Fine dust & debris removal", "Paint, sticker & film removal", "Final polish for walkthroughs"],
  },
];

const Services = () => (
  <section id="services" className="py-20 md:py-28">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="max-w-2xl mb-12 md:mb-16">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#990000] mb-3">What we do</p>
        <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight leading-snug">
          Cleaning plans built around <span className="italic text-[#990000]">your</span> home
        </h2>
      </div>
      <div className="grid md:grid-cols-2 gap-5 md:gap-6">
        {services.map((s, i) => (
          <motion.div
            key={s.id}
            data-testid={s.testid}
            initial={{ opacity: 0, y: 28 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ delay: i * 0.08, duration: 0.55 }}
            className="group bg-white border border-[#E5DEC9] rounded-3xl p-7 md:p-9 shadow-sm hover:shadow-lg hover:-translate-y-1 transition-all duration-300"
          >
            <div className="flex items-start justify-between">
              <div className="h-12 w-12 rounded-2xl bg-[#FDF0F0] text-[#990000] flex items-center justify-center group-hover:bg-[#990000] group-hover:text-white transition-colors duration-300">
                <s.icon size={22} />
              </div>
              <span className="font-display italic text-[#E5DEC9] text-4xl font-bold group-hover:text-[#990000]/20 transition-colors duration-300">0{i + 1}</span>
            </div>
            <h3 className="font-display text-xl sm:text-2xl font-semibold mt-6">{s.title}</h3>
            <p className="text-sm md:text-base text-[#5C5955] mt-2.5 leading-relaxed">{s.desc}</p>
            <ul className="mt-5 space-y-2">
              {s.points.map((p, j) => (
                <li key={j} className="flex items-center gap-2.5 text-sm font-medium text-[#2D2D2D]">
                  <span className="h-5 w-5 rounded-full bg-[#FDF0F0] text-[#990000] flex items-center justify-center shrink-0"><Check size={12} strokeWidth={3} /></span>
                  {p}
                </li>
              ))}
            </ul>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default Services;
